import React from 'react';

const Input = (props) => {
	
  const { disabled, id, error, errorMessage, label, onChange, placeholder, type, value, className, autoComplete } = props;
  return (
    <div className='form-floating form-floating-sm'>
      <input
        id={ id }
        type={ type || 'text' }
        disabled={ disabled }
        placeholder={ placeholder || '' }
        className={ `form-control ${(error ? 'is-invalid' : '')} ${className}` }
        value={ value }
        onChange={ onChange }
        autoComplete={ autoComplete }
      />
      {label?.length > 0 && (
        <label className='form-label' htmlFor={ id }> { label } </label>
      )}
      { error && (
        <div className='invalid-feedback'> { errorMessage } </div>
      )}
    </div>
  );
};

export default Input;